import React from 'react';
import { View } from 'react-native';

/**
 * Stand-in for `repeat(auto-fill, minmax(230px, 1fr))`. React Native has no CSS
 * grid, so cards flex-wrap off a 230px basis, which collapses to one column on
 * a phone and fills the row on a desktop browser.
 */
export const CARD_MIN_WIDTH = 230;

export function ItemGrid({ children }: { children: React.ReactNode }) {
  return (
    <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 14 }}>
      {React.Children.map(children, (child, i) =>
        child == null ? null : (
          <View key={i} style={{ flexGrow: 1, flexBasis: CARD_MIN_WIDTH, minWidth: 0 }}>
            {child}
          </View>
        ),
      )}
    </View>
  );
}
